import { ALMANAC_CORE_WORKSPACE } from 'utils/constants'
import { useAuth } from './UseAuth'
import { UserRole } from 'types'

export const useAlmanacWorkspace = () => {
  const auth = useAuth()

  return {
    ...ALMANAC_CORE_WORKSPACE,
    role: !!auth ? UserRole.MEMBER : UserRole.UNAUTHED,
  }
}
